export default __webpack_public_path__ + "static/media/header-bg-kalendar-2.3d6e15d2.jpg";